import { APIThunkResult } from '../Types';
import { apiFetchFile, apiRequest } from './Utils';
import { server } from '../../CONSTANTS';
import { setNotification } from '../Store/contexts/notification/actions';

const ADMIN_URL = `${server}/admin`;

export interface BulkUploadPointsRequest {
  excelFile: File;
  companyId?: number;
  eventId: number;
  rewardId: number;
}

export interface BulkUploadPointsResponse {
  message: string;
  result: {
    errors: string[];
    success: string[];
    totalErrors: number;
    totalProcessed: number;
    totalSuccess: number;
  };
}

/**
 * Bulk upload and assign connection points to users
 */
export const bulkUploadPoints = (data: BulkUploadPointsRequest): APIThunkResult<BulkUploadPointsResponse> => {
  return apiRequest<BulkUploadPointsResponse>(async dispatch => {
    try {
      // Create FormData for multipart/form-data
      const formData = new FormData();
      formData.append('excelFile', data.excelFile);
      formData.append('eventId', data.eventId.toString());
      formData.append('rewardId', data.rewardId.toString());
      
      if (data.companyId) {
        formData.append('companyId', data.companyId.toString());
      }

      const result = await apiFetchFile<BulkUploadPointsResponse>({
        method: 'POST',
        url: `${ADMIN_URL}/bulk-upload-points`,
        body: formData
      });
      
      dispatch(
        setNotification({
          message: `Reward points allocation completed! Total Processed: ${result.result.totalProcessed}, Success: ${result.result.totalSuccess}, Errors: ${result.result.totalErrors}`,
          variant: result.result.totalErrors === 0 ? 'success' : 'warning'
        })
      );

      return result;
    } catch (error) {
      dispatch(
        setNotification({
          message: error.message || 'Something went wrong uploading points. Please try again later.',
          variant: 'danger'
        })
      );
      throw error;
    }
  });
}; 